<template>
  <div class="row transaction">
    <!-- <div class="spinner-grow" role="status" v-if="loading === true"></div> -->

    <div class="button-container mb-3 mr-4">
      <button
        type="button"
        class="btn custom-btn green-btn mr-2"
        @click="
          verifiedStatus = 'verified';
          refresh('filter');
        "
      >
        Verified KYC
      </button>
      <button
        type="button"
        class="btn custom-btn pale-btn mr-2 custom-hover"
        @click="
          verifiedStatus = 'partially_verified';
          refresh('filter');
        "
      >
        Partially Verified KYC
      </button>
      <button
        type="button"
        class="btn custom-btn yellow-btn mr-2"
        @click="
          verifiedStatus = 'pending';
          refresh('filter');
        "
      >
        Pending KYC
      </button>
      <button
        type="button"
        class="btn custom-btn red-btn mr-2"
        @click="
          verifiedStatus = 'rejected';
          refresh('filter');
        "
      >
        Rejected KYC
      </button>
      <button
        type="button"
        class="btn custom-btn blue-btn mr-2"
        @click="
          verifiedStatus = 'unverified';
          refresh('filter');
        "
      >
        Unverified
      </button>
    </div>

    <section
      style="
        background-color: #fff;
        width: 90vw;
        min-height: 100vh;
        border-radius: 20px;
        padding: 20px;
      "
    >
      <h1 class="header-text">{{ headerText }}</h1>

      <div class="input-container">
        <select
          class="form-control"
          v-model="selectedValue"
          placeholder="Select a search parameter"
        >
          <option value="">Select a search parameter</option>
          <option value="firstName">First Name</option>
          <option value="phoneNumber">Phone Number</option>
          <option value="walletId">Wallet ID</option>
          <option value="accountType">Account Type</option>
        </select>

        <div
          class="input-error"
          v-if="
            selectedValue === 'firstName' ||
            selectedValue === 'phoneNumber' ||
            selectedValue === 'walletId'
          "
        >
          <input
            type="text"
            class="form-control"
            v-model="searchValue"
            :placeholder="`Enter ${formattedSearchValue}`"
          />
        </div>

        <div class="col-auto" v-if="selectedValue === 'accountType'">
          <select
            class="form-control"
            v-model="searchValue"
            placeholder="Select a search parameter"
          >
            <option value="">Select an account type</option>
            <option value="individual-account">Individual Account</option>
            <option value="business-account">Business Account</option>
          </select>
        </div>

        <button
          class="btn custom-btn"
          @click="refresh('filter')"
          :disabled="isSearchDisabled"
        >
          Search
        </button>
        <button class="btn custom-btn" @click="refresh('download')">
          Download List
        </button>
        <button class="btn custom-btn" @click="refresh('reload')">
          Refresh
        </button>
      </div>

      <div class="col-12 p-0">
        <card class="card-plain p-0">
          <div class="table-full-width table-responsive table-container p-0">
            <table class="table">
              <thead class="thead-dark">
                <tr>
                  <th class="text-center">S/N</th>
                  <th class="text-center">First Name</th>
                  <th class="text-center">Middle Name</th>
                  <th class="text-center">Last Name</th>
                  <th class="text-center">Phone Number</th>
                  <th class="text-center">Wallet ID</th>
                  <th class="text-center">Account Type</th>
                  <th class="text-center">Tier</th>
                  <th class="text-center">KYC Status</th>
                  <th class="text-center">Date Created</th>
                  <th class="text-center">Last Updated</th>
                  <th class="text-center">Action</th>
                </tr>
              </thead>

              <tbody>
                <tr v-if="loading === true">
                  <td colspan="100%" class="text-center">
                    <div>
                      <div class="spinner-border text-primary" role="status">
                        <span class="sr-only">Loading...</span>
                      </div>
                    </div>
                  </td>
                </tr>

                <tr v-else-if="agentList.length === 0 && loading === false">
                  <td colspan="100%" class="text-center">
                    <div class="">
                      <div class="alert-icon">
                        <i class="fa fa-info-circle"></i>
                      </div>
                      <span>No Agents Found</span>
                    </div>
                  </td>
                </tr>
                <tr
                  v-else
                  v-for="(agent, index) in agentList"
                  :key="agent._id"
                  style="background-color: #fff"
                >
                  <td>{{ limit * (page - 1) + (index + 1) }}</td>
                  <td class="text-center">{{ agent.firstName }}</td>
                  <td class="text-center">{{ agent.middleName }}</td>
                  <td class="text-center">{{ agent.lastName }}</td>
                  <td class="text-center">{{ agent.phoneNumber }}</td>
                  <td class="text-center">{{ agent.walletId }}</td>
                  <td class="text-center" style="text-transform: capitalize">
                    {{ removeAccountSuffix(agent.accountType) }}
                  </td>
                  <td class="text-center text-uppercase">
                    <span>{{ agent.tier ? agent.tier.slice(-1) : "" }}</span>
                  </td>
                  <td class="text-center">
                    <span
                      class="statuses"
                      :class="{
                        'all-status-verified':
                          agent.verifiedStatus === 'verified',
                        'all-status-partially-verified':
                          agent.verifiedStatus === 'partially_verified',
                        'all-status-rejected':
                          agent.verifiedStatus === 'rejected',
                        'all-status-pending':
                          agent.verifiedStatus === 'pending',
                        'all-status-unverified':
                          agent.verifiedStatus === 'unverified',
                      }"
                      >{{ getFormattedStatus(agent.verifiedStatus) }}</span
                    >
                  </td>
                  <td class="text-center">
                    {{ moment(agent.createdAt).format("DD-MM-YYYY") }}
                  </td>
                  <td class="text-center">
                    {{ moment(agent.updatedAt).format("DD-MM-YYYY") }}
                  </td>
                  <td class="text-center">
                    <router-link
                      :to="
                        agent.accountType === 'business-account'
                          ? `/dashboard/business-agent-kyc/${agent._id}`
                          : `/dashboard/agent-kyc/${agent._id}`
                      "
                    >
                      View Details
                    </router-link>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </card>
      </div>

      <div class="paginate-btns">
        <div style="display: flex; align-items: center; gap: 20px">
          <button
            class="btn"
            style="border: none"
            :disabled="!hasPrevPage"
            @click="refresh('previous')"
          >
            Previous
          </button>

          <span>Page {{ currentPage }} of {{ totalPages }}</span>

          <button
            class="btn"
            style="border: none"
            :disabled="!hasNextPage"
            @click="refresh('next')"
          >
            Next
          </button>
        </div>

        <div class="">
          <div class="btn" style="border: none">
            Total Records: {{ totalDocs }}
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import axios from "../store/axios";
import moment from "moment";
import Swal from "sweetalert2";
import fileDownload from "js-file-download";
import { convertArrayToCSV } from "convert-array-to-csv";

export default {
  data() {
    return {
      loading: false,
      error: false,
      page: 1,
      limit: 50,
      totalPages: 0,
      download: false,
      currentPage: 1,
      totalDocs: 0,
      hasPrevPage: false,
      hasNextPage: false,
      nextPage: null,
      prevPage: null,
      agentList: [],
      filteredAgentList: [],
      moment,
      headerText: "ALL ACCOUNTS KYC",
      inputError: false,
      currentPage: 1,
      loading: false,
      error: false,
      errorMsg: "",
      moment,
      searchValues: {
        walletId: "",
        phoneNumber: "",
        firstName: "",
        accountType: "",
      },
      selectedValue: "",

      verifiedStatus: "",
      inputError: false,
    };
  },

  computed: {
    formattedSearchValue() {
      return this.selectedValue
        ? this.selectedValue
            .replace(/([a-z])([A-Z])/g, "$1 $2")
            .replace(/\b\w/g, (char) => char.toUpperCase())
        : "";
    },

    searchValue: {
      get() {
        return this.selectedValue ? this.searchValues[this.selectedValue] : "";
      },
      set(value) {
        if (this.selectedValue) {
          this.searchValues[this.selectedValue] = value;
        }
      },
    },

    isSearchDisabled() {
      switch (this.selectedValue) {
        case "accountType":
          return !this.searchValue;

        case "firstName":
          return !this.searchValue || this.searchValue.trim().length === 0;

        case "walletId":
        case "phoneNumber":
          return !this.searchValue || !/^\d+$/.test(this.searchValue);

        default:
          return true;
      }
    },
  },

  methods: {
    removeAccountSuffix(accountType) {
      return (accountType || "").replace("-account", "");
    },

    getFormattedStatus(status) {
      const statusMap = {
        verified: "Verified",
        partially_verified: "Partially Verified",
        rejected: "Rejected",
        pending: "Pending",
        unverified: "Unverified",
      };
      return statusMap[status] || status;
    },

    updateHeader() {
      switch (this.verifiedStatus) {
        case "verified":
          this.headerText = "VERIFIED KYC";
          break;
        case "partially_verified":
          this.headerText = "PARTIALLY VERIFIED KYC";
          break;
        case "pending":
          this.headerText = "PENDING KYC";
          break;
        case "unverified":
          this.headerText = "UNVERIFIED KYC";
          break;
        case "rejected":
          this.headerText = "REJECTED KYC";
          break;
        default:
          this.headerText = "ALL ACCOUNTS KYC";
          break;
      }
    },

    async refresh(mode) {
      try {
        this.errorMsg = "";
        this.error = false;
        this.loading = true;
        let payload = {
          page: this.page,
          firstName: this.firstName,
          download: this.download,
          verifiedStatus: this.verifiedStatus,
          ...this.searchValues,
        };
        switch (mode) {
          case "next":
            payload = { ...payload, page: this.nextPage };
            this.currentPage = this.nextPage;
            break;
          case "previous":
            payload = { ...payload, page: this.prevPage };
            this.currentPage = this.prevPage;
            break;
          case "download":
            payload = { ...payload, download: true };
            break;
          case "filter":
            this.page = 1;
            this.currentPage = 1;

            payload = {
              page: this.page,
              verifiedStatus: this.verifiedStatus,
              ...this.searchValues,
            };
            this.updateHeader();
            break;
          case "reload":
            this.page = 1;
            this.headerText = "ALL ACCOUNTS KYC";
            payload = {
              page: this.page,
            };
            this.selectedValue = "";
            this.searchValues = "";
            this.verifiedStatus = "";
            this.currentPage = 1;
            break;
        }

        const res = await axios.post(
          `${process.env.VUE_APP_API_URL}/agent-list`,
          payload,
        );

        if (mode === "download") {
          const csvTran = convertArrayToCSV(res.data.agentList);
          fileDownload(csvTran, "agents_list.csv");
        } else {
          const {
            docs,
            hasNextPage,
            hasPrevPage,
            totalPages,
            prevPage,
            nextPage,
            totalDocs,
            page,
          } = res.data.agentList;
          this.merchants = docs.map((merchant) => ({
            ...merchant,
            isDropdownOpen: false,
          }));
          this.agentList = docs;
          this.filteredAgentList = docs;
          this.hasPrevPage = hasPrevPage;
          this.hasNextPage = hasNextPage;
          this.totalPages = totalPages;
          this.prevPage = prevPage;
          this.nextPage = nextPage;
          this.totalDocs = totalDocs;
          this.page = page;
        }
      } catch (err) {
        console.log(err);
        this.error = true;
        this.errorMsg = "Unable to Download Agents List";
      }
      this.loading = false;
    },

    clearSearchFields() {
      this.searchValues = {
        terminalId: "",
        walletId: "",
        phoneNumber: "",
        firstName: "",
        accountType: "",
        reference: "",
        stan: "",
      };
    },
  },

  watch: {
    selectedValue() {
      this.clearSearchFields();
      this.refresh("filter");
    },
  },

  async mounted() {
    try {
      this.loading = true;
      const res = await axios.post(
        `${process.env.VUE_APP_API_URL}/agent-list`,
        {
          page: this.page,
        },
      );
      const {
        docs,
        hasNextPage,
        hasPrevPage,
        totalPages,
        prevPage,
        nextPage,
        totalDocs,
        page,
      } = res.data.agentList;
      this.agentList = docs;
      this.filteredAgentList = docs;
      this.hasPrevPage = hasPrevPage;
      this.hasNextPage = hasNextPage;
      this.totalPages = totalPages;
      this.prevPage = prevPage;
      this.nextPage = nextPage;
      this.totalDocs = totalDocs;
      this.page = page;
    } catch (err) {
      console.log(err);
      this.error = true;
      this.errorMsg = "Unable to Fetch Agents";
    }
    this.loading = false;
  },
};
</script>

<style scoped>
.custom-btn {
  padding: 12px 36px;
  border: none;
}

.green-btn {
  background: #00c307;
}

.pale-btn {
  background: #b5af03;
}

.yellow-btn {
  background: #f2b630;
}

.red-btn {
  background: #e02b00;
}

.blue-btn {
  background: #6880e4;
}

.header-text {
  font-size: 20px;
  font-weight: 600;
  margin-left: 15px;
  text-transform: uppercase;
}

.input-container {
  display: flex;
  align-items: center;
  gap: 16px;
  margin-bottom: 16px;
}

.input-container select {
  width: 100%;
  max-width: 275px;
  border: none;
  outline: none;
  background: #f2f1ed;
  padding: 12px;
  color: #9497b8;
}

.input-container button {
  background: #65b3c7;
}

.statuses {
  text-transform: capitalize;
  font-size: 14px;
  border-radius: 4px;
  padding: 4px 12px;
  display: flex;
  justify-content: center;
}

.all-status-verified {
  color: #1eb75b;
  background: rgba(30, 183, 91, 0.1);
}
.all-status-partially-verified {
  color: #b5af03;
  background: rgba(181, 175, 3, 0.1);
}
.all-status-rejected {
  color: #e02b00;
  background: rgba(224, 43, 0, 0.1);
}
.all-status-pending {
  color: #f2b630;
  background: rgba(242, 182, 48, 0.1);
}
.all-status-unverified {
  color: #6880e4;
  background: rgba(104, 128, 228, 0.1);
}

.input-error {
  position: relative;
}

.input-error div {
  position: absolute;
  margin-top: 2px;
  color: #e02b00;
  font-weight: 600;
}
.paginate-btns {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
}
</style>
